(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bk-e-voucher-gift"] && !Shopify.designMode) return;
  try {
    (function () {
  function syncRecipientRequirements(container) {
    var checkbox = container.querySelector('input[type="checkbox"][name="properties[__shopify_send_gift_card_to_recipient]"]');
    var email = container.querySelector('input[name="properties[Recipient email]"]');
    if (checkbox && email) email.required = checkbox.checked;
  }
  document.querySelectorAll('.product-gift').forEach(syncRecipientRequirements);
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== 'properties[__shopify_send_gift_card_to_recipient]' || input.type !== 'checkbox') return;
    var container = input.closest('.product-gift');
    if (container) syncRecipientRequirements(container);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
